import { ReactElement, Fragment } from "react";
import { Box } from "@twilio-paste/core/box";
import {
  ChatLog as PasteChatLog,
  ChatBookend,
  ChatBookendItem,
} from "@twilio-paste/core/chat-log";

import ChatMessage from "../chatMessage";
import { copy, types } from "./definitions";
import { sortChatMessagesByRelativeTime } from "./utils";
import BlockRenderer from "../blockRenderer";
import { useWiseOwlContext } from "../../hooks";
import { FetchChatLoader } from "../../views/WiseOwlChat/sub";

const ChatLog = ({
  blocks = [],
  chatMessages,
  formatDatePastYesterday,
}: types.WiseOwlChatLogProps): ReactElement => {
  const { loadingConfiguration } = useWiseOwlContext();
  const shouldRenderChatLog = !!blocks.length || !!chatMessages?.length;

  const renderChatLog = (): ReactElement | ReactElement[] => {
    // TODO: Potentially deprecate after API integration
    if (chatMessages) {
      const messagesRenderedByRelativeTime = sortChatMessagesByRelativeTime(
        chatMessages,
        formatDatePastYesterday
      );

      const renderedChatMessages = Object.keys(
        messagesRenderedByRelativeTime
      ).map((timeLineKey, index) => (
        <Fragment key={index}>
          <ChatBookend>
            <ChatBookendItem>{timeLineKey}</ChatBookendItem>
            {index === 0 && (
              <ChatBookendItem>
                <strong>{copy.messages.startBookend}</strong>
              </ChatBookendItem>
            )}
          </ChatBookend>

          {messagesRenderedByRelativeTime[timeLineKey].map((chatMessage) => (
            <ChatMessage {...chatMessage} />
          ))}
        </Fragment>
      ));

      return renderedChatMessages;
    }

    return <BlockRenderer blocks={blocks} />;
  };

  return (
    <Box
      overflow={"auto"}
      backgroundColor="colorBackgroundBody"
      position={"relative"}
      paddingTop={["space0", "space70"]}
    >
      <PasteChatLog>
        {loadingConfiguration.fetchChatById && <FetchChatLoader />}
        {!loadingConfiguration.fetchChatById &&
          shouldRenderChatLog &&
          renderChatLog()}
      </PasteChatLog>
    </Box>
  );
};

export default ChatLog;
